interface Credentials {
    applicationId: string;
    clientToken: string;
}

export const credentials: Credentials = {
    applicationId: '20dd54df-eb9a-4726-b310-d72ce3379d1e',
    clientToken: 'pubfe0e2cfa017b2aabc4a86e19f46b92f0',
};